<template>
  <div>
    <div ref="dom3" class="line3"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("transactionStatistics", ["threeEchertsData"]),
  },
  components: {},
  mounted() {},
  watch: {
    threeEchertsData: {
      handler(val, oldVal) {
        val &&
          val.length > 0 &&
          this.$nextTick(() => {
            this.showChart(val);
          });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showChart(val) {
      const mychart = this.$echarts.init(this.$refs.dom3);
      const option = {
        legend: {
          data: val.map((i) => i.zh),
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          // axisLine: { show: false }, //隐藏x轴线
          // axisTick: { show: false }, //隐藏x轴刻度
          axisTick: {
            alignWithLabel: true,
          },
          data: val[0].tradeReport.map((i) => i.time),
        },
        // color: ["#5470c6"],
        yAxis: {
          type: "value",
        },
        series: val.map((i) => {
          return {
            name: i.zh,
            type: "line",
            data: i.tradeReport.map((i) => i.result),
          };
        }),
      };
      mychart.setOption(option);
      window.addEventListener("resize", () => {
        mychart.resize();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.line3 {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
}
</style>
